/**
 * 根据 items 对象找 id名 id值的item对象
 * @param items 要找的对象
 * @param id    id的名字
 * @param idVal id的值
 * @param subname   子元素名字
 */
function findItem(items, id, idVal, subname) {
    if (items && items.length != 0) {
        for (let item of items) {
            if (item[id] === idVal) {
                return item;
            } else {
                let it = findItem(item[subname], id, idVal, subname)
                if(it){
                    return it
                }
            }
        }
    }
    return null;
}

/**
 * 根据 items 对象找 'id' id值的item对象
 * @param items
 * @param idVal
 */
function findItemDefault(items, idVal) {
    return findItem(items, 'id', idVal, 'children')
}

/**
 * 根据items找到id所在的下标 拿到的是反向的
 * @param items
 * @param id
 * @param idVal
 * @param subname
 */
function findSubscript(items, id, idVal, subname){
    let indexs = [];
    if (items && items.length != 0) {
        for (let item in items) {
            if (items[item][id] === idVal) {
                indexs.push(item)
                return indexs;
            } else {
                let it = findSubscript(items[item][subname], id, idVal, subname)
                if(it && it.length != 0){
                    it.push(item)
                    return it
                }
            }
        }
    }
    return null;
}

/**
 * 返回反转后的  下标
 * @param items
 * @param idVal
 */
function findSubscriptDefault(items,idVal){
    let item =  findSubscript(items, 'id', idVal, 'children')
    if(item){
        item.reverse()
    }
    return item
}

export default {
    findItem, findItemDefault,findSubscript,findSubscriptDefault
}
